import { Controller } from "@hotwired/stimulus"

// Sello de frescura (FND.T3): reescribe un instante absoluto como "hace 12 s"
// y lo mantiene al día con su propio tick. El markup server-side trae la fecha
// completa, así que sin JS el dato sigue siendo legible; este controller solo
// lo traduce a la pregunta que el operador se hace de verdad ("¿esto sigue
// vivo?") y conmuta el color del sello: VERDE dentro del umbral del elemento,
// gris stale (is-stale) si lo excede — un criterio único para toda la app (el
// verde/gris lo pintan los estilos de _last_update.scss; el server ya estampa
// is-stale cuando el dato llega vencido, así que nunca hay verde fugaz).
//
// El texto se arma con Intl.RelativeTimeFormat en el locale del documento: no
// duplicamos las cadenas de tiempo en i18n ni en el server.
//
// values:
//   datetime  ISO8601 del instante a medir (obligatorio)
//   warnAfter segundos tras los cuales el sello se marca viejo — el UMBRAL
//             DEL ELEMENTO (V2::SensorTimeouts por formato) que pasa el
//             componente vía data attribute (default 90 s, sin
//             umbral del elemento)
//   interval  segundos entre recálculos (default 10)
const UNITS = [
  { unit: "second", seconds: 1 },
  { unit: "minute", seconds: 60 },
  { unit: "hour", seconds: 3600 },
  { unit: "day", seconds: 86400 }
]
const STALE = "is-stale"

export default class extends Controller {
  static targets = ["text"]
  static values = {
    datetime: String,
    warnAfter: { type: Number, default: 90 },
    interval: { type: Number, default: 10 }
  }

  connect() {
    this.render()
    this._timer = setInterval(() => this.render(), this.intervalValue * 1000)
  }

  datetimeValueChanged() {
    this.render()
  }

  disconnect() {
    clearInterval(this._timer)
  }

  render() {
    const at = Date.parse(this.datetimeValue)
    if (Number.isNaN(at)) return

    const elapsed = Math.max(0, Math.round((Date.now() - at) / 1000))
    if (this.hasTextTarget) this.textTarget.textContent = this.phrase(elapsed)
    this.element.classList.toggle(STALE, elapsed > this.warnAfterValue)
  }

  // La unidad más grande que no deje el número en cero: 45 → segundos,
  // 240 → minutos. numeric:"auto" deja que el locale diga "hace un minuto".
  phrase(elapsed) {
    const { unit, seconds } = UNITS.filter((u) => elapsed >= u.seconds).pop() || UNITS[0]
    const formatter = new Intl.RelativeTimeFormat(this.locale, { numeric: "auto", style: "narrow" })
    return formatter.format(-Math.floor(elapsed / seconds), unit)
  }

  get locale() {
    return document.documentElement.lang || undefined
  }
}
